const map = {
	"./AllThatApply.svg": 80746,
	"./AppointmentScheduler.svg": 33098,
	"./CalendarDate.svg": 32418,
	"./FullText.svg": 25502,
	"./MultipleChoice.svg": 75289,
	"./MultipleChoiceConsent.svg": 42193,
	"./Text.svg": 16457,
	"./Time.svg": 82183,
	"./TimeCalendar.svg": 45813,
	"./TrueOrFalse.svg": 30900
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14058;